import { createApiAction } from '@app/packages/api/utils'
import type { ApiEncryptionKey } from '@app/packages/api/v2/types/entities'

export const postEncryptionPublicKeys = () =>
  createApiAction('postEncryptionPublicKeys', dispatch => dispatch<{ data: ApiEncryptionKey }>({ method: 'POST', endpoint: '/api/v2/encryption/public_keys' }))
